// extracted by mini-css-extract-plugin
export var centerText = "_d4-8";
export var container = "_d4-0";
export var doughnutContainer = "_d4-7";
export var legend = "_d4-a";
export var legendItemColorDisplay = "_d4-b";
export var legendItemLabel = "_d4-d";
export var legendItemValue = "_d4-c";
export var lg = "_d4-5";
export var maxWidth = "_d4-9";
export var md = "_d4-4";
export var responsive = "_d4-6";
export var sm = "_d4-3";
export var xs = "_d4-2";
export var xxs = "_d4-1";